export const noticeSchema = {
    type: 'objet',
    properties: {
        noticecategorycolors: {
            type: 'object',
            properties: {
                emergency: { type: 'string' },
                default: { type: 'string' },
            },
        },
    },
};
